import { ValidationMessage } from '@sdbn/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppClientConfigurationService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-scan-barcode',
  templateUrl: './scan-barcode.component.html',
  styleUrls: ['./scan-barcode.component.scss']
})
export class ScanBarcodeComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  private terminalHardwareConnectorUrl: string;

  private maxRetries = 5;
  private retryCount = 0;

  messageDictionaryKey = 'tmc-yard.widgets.registration-terminal.barcode-scan.description';
  showHint = false;
  scannedCode: string;
  validationMessage: ValidationMessage;

  timeout = null;

  constructor(
    private configurationService: AppClientConfigurationService,
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'validationMessage') {
      this.validationMessage = contextChange.value;
      this.showHint = true;
      setTimeout(() => { this.startScanner(); }, 500);
    }
  }

  onSetElementAndContext() {
  }

  ngOnInit(): void {
    const hardwareConnectorProperty = this.configurationService.getDeviceParameter('terminalhardwareconnector.url');
    if (hardwareConnectorProperty == null) {
      console.error('Misconfiguration detected. No TerminalHardwareConnector URL configured');
      this.showScannerErrorMessage();
    } else {
      this.terminalHardwareConnectorUrl = hardwareConnectorProperty.value;
      this.startScanner();
      this.pollForScannedCode();
      this.timeout = setTimeout(() => { this.showHint = true; }, 10000);
    }
  }

  ngOnDestroy(): void {
    this.stopScanner();
  }

  private startScanner() {
    this.appServerAPI.execute(this.terminalHardwareConnectorUrl + '/io/barcode/start-scanning', {}).subscribe(response => {
      this.pollForScannedCode();
    },
    error => {
      console.error('Failed to call terminal hardware connector. Reason:', error );
      this.showScannerErrorMessage();
    });
  }

  private stopScanner() {
    console.log('execute stop scanner');
    this.appServerAPI.execute(this.terminalHardwareConnectorUrl + '/io/barcode/stop-scanning', {}).subscribe(response => {

    },
    error => {
      console.error('Failed to call terminal hardware connector. Reason:', error );
    });
  }

  private pollForScannedCode() {
    this.retryCount = this.retryCount + 1;
    this.appServerAPI.execute(this.terminalHardwareConnectorUrl + '/io/barcode/get-scanned-data', {}).subscribe(response => {
      console.log('Received barcode scan result:', response);
      if (response != null) {
        this.scannedCode = response['value'];
        this.dashboardContext.setContextValue('barcodeScanned', this.scannedCode);
        this.stopScanner();
      } else if (this.scannedCode == null && this.retryCount <= this.maxRetries) { // retry
        this.pollForScannedCode();
      }
    },
    error => {
      console.error('Failed to call terminal hardware connector. Reason:', error );
      if (this.retryCount <= this.maxRetries) { // retry
        this.pollForScannedCode();
      } else {
        this.showScannerErrorMessage();
      }
    });
  }

  private showScannerErrorMessage() {
    if (this.timeout != null) {
      clearTimeout(this.timeout);
    }
    this.messageDictionaryKey = 'tmc-yard.widgets.registration-terminal.barcode-scan.connect-error';
  }

}
